/** Derive public model URLs from game asset paths (matches scripts/extract-items.py). */

export function assetPathToModelUrl(assetPath: string | null | undefined, ext: 'glb' | 'usda'): string | null {
  if (!assetPath || !String(assetPath).trim()) return null
  const p = String(assetPath).replace(/\\/g, '/').trim()
  const lower = p.toLowerCase()
  const stem = lower.endsWith('.cgf') ? p.slice(0, -4) : p.replace(/\.[^./\\]+$/, '')
  const rel = `${stem}.${ext}`.replace(/^\/+/, '')
  return `/game/${rel}`
}

export function assetPathToModelGltfUrl(assetPath: string | null | undefined): string | null {
  return assetPathToModelUrl(assetPath, 'glb')
}

export function assetPathToModelUsdaUrl(assetPath: string | null | undefined): string | null {
  return assetPathToModelUrl(assetPath, 'usda')
}

export function isGltfModelUrl(url: string): boolean {
  const lower = url.toLowerCase()
  return lower.endsWith('.glb') || lower.endsWith('.gltf')
}
